"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventEmitter = void 0;
const react_1 = require("react");
const _1 = require(".");
function useEmit() {
    const em = (0, react_1.useContext)(_1.EventEmitterContext);
    return (0, react_1.useCallback)((type, ...args) => {
        em === null || em === void 0 ? void 0 : em.emit(type, ...args);
    }, [em]);
}
function useEventEmitter() {
    const emit = useEmit();
    return {
        useListener: (type, listener, deps = []) => {
            const em = (0, react_1.useContext)(_1.EventEmitterContext);
            (0, react_1.useEffect)(() => {
                const isValue = String(type).match("undefined") === null;
                if (isValue) {
                    em === null || em === void 0 ? void 0 : em.add(type, listener);
                    return () => {
                        em === null || em === void 0 ? void 0 : em.remove(type, listener);
                    };
                }
                else {
                    return;
                }
            }, [listener, type, ...deps]);
        },
        emit,
    };
}
exports.useEventEmitter = useEventEmitter;
